import { Injectable } from '@angular/core';
import { CustomersAPIService } from '../API/CustomersAPI.service';

@Injectable({
  providedIn: 'root'
})
export class CustomersService{
  configUrl: string;

    constructor(private customerService: CustomersAPIService) {
  }

  public getRefererClient() {
    return this.customerService.getRefererClient();
  }

  public getAll() : any {
    return this.customerService.getAll();
  }

  getCustomerById() {
    return this.customerService.getCustomerById();
  }

  getDataGPSCitronellaById() {
    console.log("/api/Customer/GetGPSDataByClientId/");
    return this.customerService.getDataGPSCitronellaById();
  }
}
